import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBlBIMGAdBY7Azk244EXZ1_3-BJCpNHWmk",
  authDomain: "retail-jkommerce-poc.firebaseapp.com",
  projectId: "retail-jkommerce-poc",
  storageBucket: "retail-jkommerce-poc.firebasestorage.app",
  messagingSenderId: "218142584790",
  appId: "1:218142584790:web:4c10309ff56d1d4ca77e77",
  measurementId: "G-J2TEKV4PZK"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);